// extracted by mini-css-extract-plugin
export default {"wrapper":"Gw-z","button":"Hw-z","alternate":"Iw-z","disabled":"Jw-z","paymentWarning":"Kw-z","fadeIn":"Lw-z"};